import React from 'react'
import {
    IconArrowBigLeftFilled, IconHome,
} from '@tabler/icons-react'
import { Link } from 'react-router-dom'
import { useTheme } from './ThemeContext';

export default function Breadcrumb({ title, path }) {

    const { isActive, sidebarToggle } = useTheme();

    return (
        <div className='flex items-center justify-between flex-wrap gap-15 mb-20'>
            <div className='text-[22px]/[28px] font-medium flex items-center gap-5'>
                <button aria-label="sidebar arrow icon" onClick={sidebarToggle} className='py-[6px] pr-[12px] xl:block hidden'>
                    <IconArrowBigLeftFilled className={`w-[16px] h-[16px] text-blue transition-all duration-300 ease-in-out hover:text-blue-100 ${isActive ? 'rotate-0' : 'rotate-180'}`} />
                </button>
                {title}
            </div>
            {/* <div className='flex items-center gap-5'>
                <Link aria-label="home icon" to="/">
                    <IconHome className='text-blue stroke-[1.5px] w-[18px] h-[18px] transition-all duration-300 ease-in-out hover:text-blue-100' />
                </Link>
                <span className='text-text-primary inline-block'>
                    &nbsp;/ &nbsp;{path}
                </span>
            </div> */}
        </div>
    )
}
